import { Button, Form, InputNumber, Space, Input } from "antd";
import axios from "axios";
import moment from "moment";
import { useContext, useEffect } from "react";
import {
  CustomerOrderInfo,
  NotificationInfo,
  UserInfo,
} from "../../../../context";
import TextArea from "antd/es/input/TextArea";

const VoidSpecProduct = ({
  //   form2,
  dialogData,
  getMerchantInvoiceDetails,
  selectedProduct,
  orderlength,
  close,
  closeDiag,
}) => {
  const { rerunNotif } = useContext(NotificationInfo);
  const { userData } = useContext(UserInfo);
  const { rerunToProduction, rerunNowServing } = useContext(CustomerOrderInfo);
  const [form2] = Form.useForm();

  const handleVoidSpecProd = (values) => {
    const formdata = new FormData();
    formdata.append(
      "user_id",
      userData.data.usersmerchantemployee.merchant_user_id
    );
    formdata.append(
      "merchant_uid",
      userData.data.usersmerchantemployee.merchant_uid
    );
    formdata.append("id", dialogData !== null ? dialogData.id : "");
    formdata.append(
      "transaction_id",
      dialogData !== null ? dialogData.transaction_id : ""
    );
    formdata.append(
      "product_id",
      dialogData !== null ? dialogData.product_id : ""
    );
    formdata.append(
      "description",
      dialogData !== null ? dialogData.description : ""
    );
    formdata.append("price", dialogData !== null ? dialogData.price : "");
    formdata.append(
      "order_quantity",
      dialogData !== null ? dialogData.quantity : ""
    );
    formdata.append(
      "created_at",
      dialogData !== null
        ? moment.utc(dialogData.created_at).format("YYYY-MM-DD HH:mm:ss")
        : ""
    );

    for (const name in values) {
      formdata.append(name, values[name]);
    }

    axios
      .post("user/merchant/spec/void-product-from-cashier", formdata)
      .then((response) => {
        const data = response.data;
        if (data === "success") {
          rerunNotif("success", "Void product successfully.");
          setTimeout(() => {
            if (orderlength > 1) {
              getMerchantInvoiceDetails();
              closeDiag();
            } else {
              close();
            }
            rerunToProduction();
            rerunNowServing();
          }, 1000);
        }
      })
      .catch((error) => {
        console.log("ERROR: ", error);
      });
  };

  useEffect(() => {
    form2.setFieldsValue({
      product: dialogData.product,
    });
  }, [dialogData]);

  return (
    <Form
      layout="vertical"
      name="void-spec-tranx"
      initialValues={{
        // product: dialogData !== null ? dialogData.product : "",
        product: selectedProduct !== null ? selectedProduct : "",
      }}
      onFinish={handleVoidSpecProd}
      autoComplete="off"
      form={form2}
    >
      <Space
        direction="vertical"
        style={{ width: "100%", margin: 0, marginTop: 20 }}
      >
        <Form.Item
          name="product"
          label="Product Name"
          // rules={[
          //   {
          //     required: true,
          //     message: "Required",
          //   },
          // ]}
        >
          <Input
            // placeholder="Set product name"
            size="large"
            disabled
          />
        </Form.Item>

        <Form.Item
          name="quantity"
          // label="Void Quantity"
          label={
            dialogData !== null && parseInt(dialogData.is_per_piece) === 1
              ? "Void Quantity"
              : "Void Gram(s)"
          }
          rules={[
            {
              required: true,
              message: "Required",
            },
          ]}
        >
          <InputNumber
            min={1}
            max={dialogData !== null ? dialogData.quantity : 0}
            size="large"
            style={{ width: "100%" }}
            step="1"
          />
        </Form.Item>
        <Form.Item
          name="reason"
          label="Reason"
          rules={[
            {
              required: true,
              message: "Required",
            },
          ]}
        >
          <TextArea
            placeholder="Set reason"
            autoSize
            size="large"
            // style={{ textTransform: "uppercase" }}
          />
        </Form.Item>
      </Space>

      <Form.Item style={{ marginTop: "20px" }}>
        <Button
          type="primary"
          // loading={loading}
          htmlType="submit"
          style={{ width: "100%", borderRadius: "20px" }}
        >
          Confirm
          {/* {loading ? "Loading" : "Add"} */}
        </Button>
      </Form.Item>
    </Form>
  );
};

export default VoidSpecProduct;
